import { isMFAEnabled } from './isMFAEnabled'

export function getInitialSettings(user = {}) {
  const {
    enabled_mfa_mechanisms: enabledMFAMechanisms = [],
    mfa_enforced: mfaEnforced = false,
    local_login_enabled: isLocalLoginEnabled = false,
  } = user
  const hasMFAEnabled = isMFAEnabled(enabledMFAMechanisms, isLocalLoginEnabled)
  return {
    enabledMFAMechanisms,
    mfaEnforced,
    hasMFAEnabled,
    isLocalLoginEnabled,
  }
}
